import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 2ADC4253-F51B-4BC2-B04C-0DDD139425CF
 * name note-text
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/note-text.svg
 * tags
 */
export const NoteTextIcon = createSvgIcon(<><path d="M14,10H19.5L14,4.5V10M5,3H15L21,9V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3M5,12V14H19V12H5M5,16V18H14V16H5Z" /></>, 'NoteTextIcon');
export default NoteTextIcon